export default {
  namespaced: true,
  state: {
    allowedHeaders: [
      "Location Master",
      "Item Master",
      "3P Claim",
      "User Master",
      "Vendor Master",
      "Approval Matrix",
      "Return Creation",
      "Replacement",
      "Restock",
      "Generate & Track Tag IDs",
      "Markdown",
      "Repair",
      "Dispatch",
      "Transfer",
      "AI Pricing File Upload",
      "BB CRM Surrogate",
      "Manage Buyers",
      "Brand Call Log",
      "Insurance",
      "D2C Return Approval",
      "Dealer/Partner Return Approval",
      "Internal Return Request Approval",
      "Warranty Claim Approval",
      "RTV",
      "Create New Approval Config",  
      "Rule Engine Profile Master"
    ]
  },
   mutations: {
    ADD_HEADER(state, newHeader) {
      if (!state.allowedHeaders.includes(newHeader)) {
        state.allowedHeaders.push(newHeader);
      }
    }
  }
};
